import { PermissionT } from "../types";

export const serviceAreaUpdates = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "service_area_updates");
  return !!p;
};

export default serviceAreaUpdates;
